<template>
  <div class="subtitleQuickMenu" @mousedown.stop>
    <li class="quick-manu-list logo" @click="close">
      <i class="icon menu-icon"></i>
      <a target="_blank" href="/templates">
        <img src="../../../../static/svg/laihua-logo-light.svg" alt="logo" />
      </a>
    </li>
    <li class="quick-manu-list file">
      <i class="icon file-icon"></i>
      <span>
        <a href="/manage" target="_blank" @click="close">作品管理</a>
      </span>
    </li>
    <li class="quick-manu-list vip">
      <i class="icon vip-icon"></i>
      <span>
        <a href="/vip" target="_blank" @click="close">会员服务</a>
      </span>
    </li>
  </div>
</template>

<script>
export default {
  name: "subtitleQuickMenu",
  model: {
    prop: "showQuickMenu",
    event: "changedShow"
  },
  data() {
    return {};
  },
  props: {
    showQuickMenu: Boolean
  },
  components: {},
  methods: {
    close() {
      this.$emit("close");
    }
  },
  mounted() {
    let _this = this;
    $("body").on("mousedown", e => {
      if (_this.showQuickMenu) {
        _this.$emit("changedShow", false);
      }
    });
  },
  watch: {},
  computed: {}
};
</script>

<style scoped lang='scss'>
.subtitleQuickMenu {
  position: relative;
  width: 220px;
  height: 100%;
  background-color: #474261;
  .quick-manu-list {
    display: flex;
    justify-content: start;
    align-items: center;
    width: 100%;
    height: 60px;
    border-top: 2px solid #393451;
    .icon {
      display: inline-flex;
      justify-content: center;
      align-items: center;
      color: #474261;
      background-color: #fff;
      font-style: normal;
      margin-left: 21px;
    }
    span {
      color: #fff;
      a {
        color: inherit;
        text-decoration: none;
      }
    }
  }
  .logo:hover,
  .file:hover,
  .new:hover,
  .template:hover,
  .story:hover,
  .vip:hover {
    span {
      opacity: 0.7;
    }
  }
  .logo {
    border: none;
    .menu-icon {
      display: inline-block;
      width: 24px;
      height: 27px;
      background-color: #fff;
      cursor: pointer;
      margin-right: 37px;
      background: url("../../../../static/svg/menu-white.svg") no-repeat center;
      &:hover {
        background: url("../../../../static/svg/menu-active.svg") no-repeat
          center;
      }
    }
    img {
      width: 64px;
      height: 18px;
    }
  }
  .file {
    cursor: pointer;
    .file-icon {
      width: 18px;
      height: 16px;
      background: url("../../../../static/svg/works.svg") no-repeat center;
    }
    span {
      margin-left: 41px;
    }
  }
  .vip {
    cursor: pointer;
    .vip-icon {
      width: 24px;
      height: 18px;
      font-size: 12px;
      font-weight: bold;
      background: url("../../../../static/svg/vip.svg") no-repeat center;
    }
    span {
      margin-left: 35px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/subtitle/quickMenu/videoQuickMenu.vue